import axios from "axios";
//let apiURL = "https://x4ph1hd2w6.execute-api.us-east-1.amazonaws.com/dev/v1";
//let apiKey="6nckv7WKqx5WGrZZwKMyK2LU7enVb14p81ZSMFeW"
let apiURL = "https://xtnzefcqrb.execute-api.us-east-1.amazonaws.com/prod/v1";
let apiKey = "s5OiHD3ENL7Yfb2tS9c0x9XBMoTXunki1yTVb3OP";

export default class UserService {
  getBrowsers(userId) {
    return axios
      .get(`${apiURL}/users/${userId}/browsers`, {
        headers: {
          'x-api-key': apiKey
        }
      })
      .then((res) => res.data.data);
  }
  approveUserBrowser(userId, browserId) {
    return axios
      .put(`${apiURL}/users/${userId}/browsers/${browserId}/approve`, {}, {
        headers: {
          'x-api-key': apiKey
        }
      })
      .then((res) => res.data);
  }
  blockUserBrowser(userId, browserId) {
    return axios
      .put(`${apiURL}/users/${userId}/browsers/${browserId}/block`, {}, {
        headers: {
          'x-api-key': apiKey
        }
      })
      .then((res) => res.data);
  }
  resetUserBrowser(userId, browserId) {
    return axios
      .put(`${apiURL}/users/${userId}/browsers/${browserId}/reset`, {}, {
        headers: {
          'x-api-key': apiKey
        }
      })
      .then((res) => res.data);
  }
  getEmailOverride(userId) {
    return axios
      .get(`${apiURL}/users/${userId}/emailoverride`, {
        headers: {
          'x-api-key': apiKey
        }
      })
      .then((res) => res.data);
  }
  setEmailOverride(userId, email) {
    return axios
      .put(`${apiURL}/users/${userId}/emailoverride`, { email }, {
        headers: {
          'x-api-key': apiKey
        }
      })
      .then((res) => res.data);
  }
  resendEmail(userId, browserId, properties, context) {
    console.log({ "event": "challenge.admin_resent", user_id: userId, retry: true, context, properties });
    return axios
      .post(`${apiURL}/challenge`, { "event": "challenge.admin_resent", user_id: userId, retry: true, context, properties }, {})
      .then((res) => res.data);
  }
}
